import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import React from 'react';
import AppProvider from './hooks/index';
import RoutesList from './routes';
import GlobalStyle from './styles/global';
import theme from './styles/theme';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({ hasError: true, error, errorInfo });
        console.error('ErrorBoundary caught:', error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: '30px', backgroundColor: '#1A1D20', color: '#FF7676', fontFamily: 'monospace', minHeight: '100vh' }}>
                    <h1 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '10px' }}>React Runtime Crash Caught</h1>
                    <p style={{ color: '#E2E8F0', marginBottom: '20px' }}>{this.state.error && this.state.error.toString()}</p>
                    <h2 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px', color: '#02EA75' }}>Component Stack:</h2>
                    <pre style={{ backgroundColor: '#0D0E10', padding: '15px', borderRadius: '8px', overflowX: 'auto', color: '#CBD5E0', fontSize: '12px', lineHeight: '1.5' }}>
                        {this.state.errorInfo && this.state.errorInfo.componentStack}
                    </pre>
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    return (
        <>
            <ColorModeScript initialColorMode={theme.config.initialColorMode} />
            <ChakraProvider theme={theme}>
                <AppProvider>
                    <ErrorBoundary>
                        <RoutesList forceRefresh={true} />
                    </ErrorBoundary>
                </AppProvider>
                <GlobalStyle />
            </ChakraProvider>
        </>
    );
}

export default App;

